import actions from 'actions'

const defaultState = {
  currentModal: null,
}

export default function common(state = defaultState, action) {
  switch (action.type) {
    case actions.COMMON_SHOW_MODAL:
      return {
        ...state,
        currentModal: action.modalName,
        currentModalArgs: action.modalArgs,
      }
    case actions.COMMON_HIDE_MODAL:
      return {
        ...state,
        currentModal: null,
        currentModalArgs: null,
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/pages/common/common.js
 **/